<template>
    <div class="layout">
        <div class="cabinet-page_bg"></div>

        <div class="content">

            <div class="content-right">
                <div class="content-right-inner">
                    <div class="logo">
                        <Logo/>
                    </div>
                    <div class="title">Восстановление пароля</div>
                    <div class="msg msg-time-over"><a href="#" v-on:click="showForgotPage" class="modal-forgot">Время ожидания истекло, запросите смену пароля повторно</a></div>

                </div>
            </div>

            <router-link :to="{name: 'Index'}" class="btn-back">
                <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 14H28M2 14L15.4729 27M2 14L15.4729 1" stroke="black" stroke-width="2"/>
                </svg> <span>На главную</span>
            </router-link>

        </div>

        <div class="forgot-page-bg"></div>
        <AuthorizationWindow/>
    </div>
</template>



<script>
    import Logo from "../components/icons/Logo";
    import AuthorizationWindow from "../components/windows/AuthorizationWindow";
    export default {
        components: {AuthorizationWindow, Logo},

        name:'PasswordRecoveryDenied',

        metaInfo: {
            title: 'Password Recovery'
        },

        beforeCreate() {
            $('body').attr('class', 'forgot-page index-layout');
        },

        mounted() {

            $('.modal-forgot').on('click', function (e) {
                e.preventDefault();
                $('.window-wrapper.window-auth').removeClass('window-open');
                $('body').addClass('blocked');
                $('.window-wrapper.window-forgot').addClass('window-open');
            });
        },

        methods: {
            showForgotPage () {
                $('.modal-forgot').click()
            }
        }
    }
</script>